import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { ComponentCanDeactivate } from '@wilson/shared-components';

@Component({
  selector: 'wilson-form-deactivate',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormDeactivateComponent implements ComponentCanDeactivate {
  submitted = false;
  isDirty = false;
  form: FormGroup;

  canDeactivate(): Observable<boolean> {
    this.isDirty = this.submitted ? false : this.form?.dirty ? true : false;
    return of(this.isDirty);
  }

  @HostListener('window:beforeunload', ['$event'])
  onbeforeunload(event) {
    if (this.isDirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
}
